import { get, post, put, del } from '../lib/apiClient';

/**
 * GET /schedules — events the caller participates in (requestor or attendee).
 * Query: startAfter/startBefore (ISO date-times), response, updatedSince,
 * limit, lastEvaluatedKey. The returned `response` field is caller-relative.
 */
export const listSchedules = (query) => get('/schedules', { query });

/** POST /schedules — ScheduleWrite body; caller becomes the requestor */
export const createSchedule = (payload) => post('/schedules', payload);

/** GET /schedules/{scheduleId} */
export const getSchedule = (scheduleId) =>
  get(`/schedules/${encodeURIComponent(scheduleId)}`);

/** PUT /schedules/{scheduleId} — requestor only */
export const updateSchedule = (scheduleId, payload) =>
  put(`/schedules/${encodeURIComponent(scheduleId)}`, payload);

/** DELETE /schedules/{scheduleId} — requestor only; notifies attendees */
export const deleteSchedule = (scheduleId) =>
  del(`/schedules/${encodeURIComponent(scheduleId)}`);

/**
 * POST /schedules/{scheduleId}/respond — attendee only;
 * response: accepted | declined | tentative.
 */
export const respondToSchedule = (scheduleId, response) =>
  post(`/schedules/${encodeURIComponent(scheduleId)}/respond`, { response });
